import { BaseSection } from "./BaseSection";
import { ConsentsSection } from "./ConsentsSection";
import { IdentityVerificationSection } from "./IdentityVerificationSection/IdentityVerificationSection";
import { MouseSignatureSection } from "./MouseSignatureSection/MouseSignatureSection";
import { SectionKey } from "./constants";
import { SectionProps } from "./types";

export const customSections: string[] = [
  SectionKey.CONSENT,
  SectionKey.PHOTO_VERIFICATION,
  SectionKey.MOUSE_SIGNATURE,
];

export function Section(props: SectionProps) {
  if (props.section.key === SectionKey.CONSENT) {
    return <ConsentsSection {...props} />;
  }

  if (props.section.key === SectionKey.IDENTITY_VERIFICATION) {
    return <IdentityVerificationSection {...props} />;
  }

  if (props.section.key === SectionKey.MOUSE_SIGNATURE) {
    return <MouseSignatureSection {...props} />;
  }

  return <BaseSection {...props} />;
}

export * from "./constants";
